import { render, staticRenderFns } from "./SupplierManualPurchasingPriceConfigs.vue?vue&type=template&id=2215a78a&"
import script from "./SupplierManualPurchasingPriceConfigs.vue?vue&type=script&lang=js&"
export * from "./SupplierManualPurchasingPriceConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports